import { createAsyncThunk } from '@reduxjs/toolkit';
import { resetActiveActionPrompt } from '../../chat/slices/promptUser';
import { clearSelectedTemplate } from '../../promptTemplates/slices/promptTemplates';
import { createNewThread } from '../api/threadsApi';
import { clearDraftPromptTemplateFromSuperstore } from '../../superstore/utils/promptTemplate';
import { BREEZE_COPILOT } from 'chatspot-core/types/CopilotAssistantTypes';
export const createThread = createAsyncThunk('threads/createThread', async ({
  assistantType = BREEZE_COPILOT,
  customCopilotId
}, {
  dispatch
}) => {
  const response = await createNewThread({
    assistantType,
    customCopilotId
  });
  // when we start a new thread, we want to reset the following:
  // - active action prompt
  // - selected template
  dispatch(resetActiveActionPrompt());
  dispatch(clearSelectedTemplate());
  void clearDraftPromptTemplateFromSuperstore();
  return response;
});